<template>

  <div>
    <el-row :gutter="12">
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>任务状态</span>
          </div>
          <div class="card_cont">
            <section v-if="markTypes.length != 0">
              <p class="p1">一次打标总计：{{ tj.markingWaiting + tj.markingReceive + tj.markingSubmit + tj.markingCancel }} 包 
                <span style="color: #00BFFF" v-if="markTypes.length&&markTypes[0]==2" >(AI打标-阿里)</span>
                <span style="color: #00BFFF" v-if="markTypes.length&&markTypes[0]==3" >(AI打标-任度)</span>
              </p>
              <ul class="card_ul">
                <li>
                  <span>待领取</span>
                  <span>{{ tj.markingWaiting }} 包</span>

                  <el-button type="text" v-if=" tj.markingWaiting>0 && flowStatus===3 && permissions.dot_repush"
                            round size="mini"
                            @click="rePush(1)">重新推送
                  </el-button>

                  <span v-if="markTypes.length&&markTypes[0]==1">正在推送人数:{{ markingOnePush || 0 }}</span>
                  <el-button v-if="markingOnePush>0 && markTypes.length&&markTypes[0]==1" type="text" round size="mini" style="padding-left: 0px"
                            @click="pushDetail(1)">查看
                  </el-button>
                </li>
                <li>
                  <span>进行中</span>
                  <span>{{ tj.markingReceive }} 包</span>
                  <el-button type="text" v-if="tj.markingReceive>0 && flowStatus===3 && markTypes.length&&markTypes[0]==1"
                            round size="mini"
                            :disabled="this.canPushRemind['markRemindOne']!=null"
                            @click="remind(1)">消息提醒
                  </el-button>
                </li>
                <li>
                  <span>已提交</span>
                  <span>{{ tj.markingSubmit }} 包</span>
                  <el-button type="text" v-if="tj.markingSubmit >0 && this.firstUrl.length > 0 " plain
                            @click.stop="rowDown(firstUrl)">下载
                  </el-button>
                </li>
                <li>
                  <span>已终止</span>
                  <span>{{ tj.markingCancel }} 包</span>
                </li>
              </ul>
            </section>
            <section v-if="markTypes.length == 2">
              <p class="p1">
                二次打标总计：{{ tj.markingTwoWaiting + tj.markingTwoReceive + tj.markingTwoSubmit + tj.markingTwoCancel }} 包
                <span style="color: #00BFFF" v-if="markTypes.length&&markTypes.length>1&&markTypes[1]==2" >(AI打标-阿里)</span>
                <span style="color: #00BFFF" v-if="markTypes.length&&markTypes.length>1&&markTypes[1]==3" >(AI打标-任度)</span>
              </p>
              <p class="note">二次打标是具有审核权限的译员对相同的包重新打标，系统将按规则抽取部分，并非全部内容打标。</p>
              <ul class="card_ul">
                <li>
                  <span>待领取</span>
                  <span>{{ tj.markingTwoWaiting }} 包</span>
                  <el-button type="text" v-if="markTypes.length&&markTypes.length>1&&markTypes[1]==1 && tj.markingTwoWaiting>0 && flowStatus===3 && permissions.dot_repush"
                            round size="mini"
                            @click="rePush(2)">重新推送
                  </el-button>

                  <span v-if="markTypes.length&&markTypes.length>1&&markTypes[1]==1">正在推送人数:{{ markingTwoPush || 0 }}</span>
                  <el-button v-if="markingTwoPush>0" style="padding-left: 0px" type="text" round size="mini"
                            @click="pushDetail(2)">查看
                  </el-button>
                </li>
                <li>
                  <span>进行中</span>
                  <span>{{ tj.markingTwoReceive }} 包</span>
                  <el-button type="text" v-if="markTypes.length&&markTypes.length>1&&markTypes[1]==1 && tj.markingTwoReceive>0 && flowStatus===3"
                            round size="mini"
                            :disabled="this.canPushRemind['markRemindTwo']!=null"
                            @click="remind(2)">消息提醒
                  </el-button>
                </li>
                <li>
                  <span>已提交</span>
                  <span>{{ tj.markingTwoSubmit }} 包</span>
                  <el-button type="text" v-if="tj.markingTwoSubmit >0 && this.secondUrl.length > 0" plain
                            @click.stop="rowDown(secondUrl)">下载
                  </el-button>
                </li>
                <li>
                  <span>已终止</span>
                  <span>{{ tj.markingTwoCancel }} 包</span>
                </li>
              </ul>
            </section>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>打标结果</span>
          </div>
          <div class="card_cont">
            <section v-if="markTypes.length != 0">
              <p class="p1">一次打标结果</p>
              <p class="p2" v-if="this.oneResult.length === 0">暂无结果</p>
              <ul class="card_ul" v-if="this.oneResult.length > 0">
                <li v-for="(item, index) in this.oneResult" :key="index">
                  <span>{{ item.optionName }}</span>
                  <span>{{ item.num }}字（{{ item.radio }}）</span>
                </li>
              </ul>
            </section>
            <section v-if="markTypes.length == 2">
              <p class="p1">二次打标结果</p>
              <p class="p2" v-if="this.twoResult.length === 0">暂无结果</p>
              <ul class="card_ul" v-if="this.twoResult.length > 0">
                <li v-for="(item, index) in this.twoResult" :key="index">
                  <span>{{ item.optionName }}</span>
                  <span>{{ item.num }}字（{{ item.radio }}）</span>
                </li>
              </ul>
            </section>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-drawer
      title="推送详情"
      :visible.sync="drawer"
      direction="ltr"
      :before-close="handleClose"
      size="75%">
      <pushDetail :orderId="orderId" :type="type" key="pushDetails" ref="pushDetails"/>
    </el-drawer>
  </div>

</template>

<script>
import {getTJInfo} from '@/api/dot/marking'
import {rePush, remind, gerRedisPushRemind, pushDetailTj} from '@/api/dot/order'
import {listFile} from '@/api/dot/file'
import {alertErroMsg, alertSuccessMsg} from "@/util/commonMsg";
import {mapGetters} from "vuex";
import pushDetail from '@/views/common/pushDetail'

export default {
  props: ['flowStatus', 'orderId'],
  components: {pushDetail},
  data() {
    return {
      firstUrl: {},
      secondUrl: {},
      markingOnePush: 0,
      drawer: false,
      markingTwoPush: 0,
      tj: {
        markingWaiting: 0,
        markingReceive: 0,
        markingSubmit: 0,
        markingCancel: 0,
        markingTwoWaiting: 0,
        markingTwoReceive: 0,
        markingTwoSubmit: 0,
        markingTwoCancel: 0
      },
      oneResult: [],
      twoResult: [],
      markTypes: [],
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  methods: {
    init() {
      getTJInfo(this.orderId).then(response => {
        this.markTypes = response.data.data.markTypes
        this.tj = response.data.data.tj
        this.oneResult = response.data.data.oneResult
        this.twoResult = response.data.data.twoResult
      })

      gerRedisPushRemind(this.orderId, 2).then(response => {
        this.canPushRemind = response.data.data
      })

      listFile({orderId: this.orderId, fileType: 10}).then(response => {
        if (response.data.data && response.data.data.length > 0) {
          this.firstUrl = response.data.data[0].fileUrl

        }
      })
      listFile({orderId: this.orderId, fileType: 11}).then(response => {
        if (response.data.data && response.data.data.length > 0) {
          this.secondUrl = response.data.data[0].fileUrl
        }
      })

      pushDetailTj(this.orderId, 1).then(res => {
        this.markingOnePush = res.data.data.trNum
      })

      pushDetailTj(this.orderId, 2).then(res => {
        console.log(res)
        this.markingTwoPush = res.data.data.trNum
      })

    },

    rowDown(downUrl) {
      window.location.href = downUrl
    },

    handleClose(){
      this.type=0
      this.drawer = false
    },

    pushDetail(type) {
      this.drawer = true
      this.type = type
    },

    rePush(type) {
      rePush(this.orderId, type).then(res => {
        if (res.data.data > 0) {
          alertSuccessMsg()
        } else if (res.data.data === -2) {
          alertErroMsg("请勿重复操作")
        } else if (res.data.data === -3) {
          alertErroMsg("没查到待领取包")
        } else if (res.data.data === -4) {
          alertErroMsg("流程不在进行中")
        } else {
          alertErroMsg("操作失败")
        }
      })
    },
    remind(type) {
      this.$alert("24小时内只能提醒一次，确定发送？", {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showCancelButton: true,
        callback: action => {

          if (action === 'confirm') {
            remind(this.orderId, type).then(res => {
              if (res.data.data > 0) {
                alertSuccessMsg()
              } else if (res.data.data === -2) {
                alertErroMsg("请勿重复操作")
              } else if (res.data.data === -3) {
                alertErroMsg("没查到待领取包")
              } else if (res.data.data === -4) {
                alertErroMsg("流程不在进行中")
              } else {
                alertErroMsg("操作失败")
              }
            })
          }
        },
      },);

    }
  }
}

</script>
<style lang="scss" scoped>
.el-card {
  background: #fafafa;

  .el-card__header {
    padding: 12px 20px;
  }

  .card_cont {
    .p1 {
      font-size: 16px;
      margin: 0;
    }

    .p2 {
      font-size: 13px;
      margin-top: 10px;
    }

    .note {
      font-size: 12px;
      margin: 0;
    }

    .card_ul {
      > li {
        width: 100%;
        list-style-type: none;

        > span {
          width: 24%;
          display: inline-block;
          margin-right: 3%;
          font-size: 14px;
        }

        button {
          font-size: 14px;
        }
      }
    }
  }
}

</style>

